export interface ContentSettingsGroup {
  // expected properties
  id: string;
  grade_minimum: number;
  grade_maximum: number;

  // optional
  block_teacher_view?: boolean;
  block_sensitive_content?: boolean;
  block_student_search?: boolean;
  date_student_search_modified?: Date;
  school_id?: string;
  district_id?: string;
  created_by_user_id?: string;
  date_archived?: Date;
  group_has_flagged_item?: boolean;
}

export enum DirectoryType {
  CLASSROOMS = "classrooms",
  FACULTY = "faculty",
  SCHOOLS = "schools",
  STUDENTS = "students",
}
